import { Component } from '@angular/core';
import { PhDetailsComponent } from '../../../../components/admin-dashboard-component/admin-approved-ph-component/ph-details-component/ph-details-component';

@Component({
  selector: 'app-approved-ph-details',
  imports: [PhDetailsComponent],
  templateUrl: './approved-ph-details.html',
  styleUrl: './approved-ph-details.scss',
})
export class ApprovedPhDetails {

}
